import { createFileRoute } from '@tanstack/react-router';

import FormSelection from '@/pages/FormSelection';

export const Route = createFileRoute('/_app/form')({
  component: FormSelection,
});
